import { render } from "./TrainingsCatalog.vue?vue&type=template&id=0c634a13&scoped=true"
import script from "./TrainingsCatalog.vue?vue&type=script&lang=js"
export * from "./TrainingsCatalog.vue?vue&type=script&lang=js"

import "./TrainingsCatalog.vue?vue&type=style&index=0&id=0c634a13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c634a13"]])

export default __exports__